import { render, staticRenderFns } from "./CtaIncomingEvent.vue?vue&type=template&id=ef2c0cb2&scoped=true"
import script from "./CtaIncomingEvent.vue?vue&type=script&lang=js"
export * from "./CtaIncomingEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2c0cb2",
  null
  
)

export default component.exports